import { ReactNode } from 'react';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { SoulBoundary } from './SoulBoundary';

interface SoulBoundaryWithQueryProps {
  children: ReactNode;
  fallbackTitle?: string;
  fallbackMessage?: string;
}

/**
 * 🔄 SoulBoundaryWithQuery - Error Boundary com Recuperação Real
 * 
 * Combina o SoulBoundary visual com QueryErrorResetBoundary do TanStack Query.
 * Quando o usuário clica em "Tentar Novamente", as queries que falharam
 * são automaticamente refetchadas.
 * 
 * Uso:
 * ```tsx
 * <SoulBoundaryWithQuery>
 *   <MinhaFeatureComQueries />
 * </SoulBoundaryWithQuery>
 * ```
 */
export function SoulBoundaryWithQuery({ 
  children, 
  fallbackTitle, 
  fallbackMessage 
}: SoulBoundaryWithQueryProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <SoulBoundary 
          onReset={reset}
          fallbackTitle={fallbackTitle}
          fallbackMessage={fallbackMessage}
        >
          {children}
        </SoulBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
